(function(){
    'use strict';

    angular
    .module('app')
    .controller('Select2modelconfigController', Select2modelconfigController)
 
    Select2modelconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function Select2modelconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.modelname = "";
        vm.tags = [];
        vm.empty = "";
        vm.multiple = false;
        vm.relacionado = false;
        vm.field = "";
        vm.fieldval = "";
        vm.update = function(){
            var j = JSON.parse($('#fieldconfig-value').val());
            j.references["modelname"] = vm.modelname;
            j.references["field"] = vm.field;
            j.references["fieldval"] = vm.fieldval;
            j.references["multiple"] = vm.multiple;
            j.references["tags"] = vm.tags;
            j.references["empty"] = vm.empty;
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
                if(typeof vm.json.references.tags!='undefined'){
                    vm.tags = vm.json.references.tags;
                }
                if(typeof vm.json.references.multiple!='undefined'){
                    vm.multiple = vm.json.references.multiple;
                }
        	}
        	vm.update();
        }
        vm.borrarTag = function(index){
            vm.tags.splice(index,1);
            vm.update();
        }
        vm.addTag = function(){
            if(typeof vm.tags=='undefined'){
                vm.tags = [];
            }
            vm.tags[vm.tags.length] = "";
            vm.update();
        }

    } 

})();